export const canUseDom = !!(
	typeof window !== 'undefined' &&
	typeof document !== 'undefined' &&
	window.document &&
	window.document.createElement
)

export let supportsPassive = false

if (canUseDom) {
	try {
		const opts = {}
		Object.defineProperty(opts, 'passive', {
			// eslint-disable-next-line getter-return
			get() {
				supportsPassive = true
			},
		})
		window.addEventListener('test-passive', null, opts)
	} catch (e) {
		//
	}
}
